const privacyPolicyText = `
سياسة الخصوصية و المسؤولية  
التاريخ: 27 مايو 2025

في CamelBits (“نحن” أو “لنا”)، نلتزم بحماية خصوصيتك وتوضيح كيفية جمع واستخدام ومشاركة معلوماتك.

1. المعلومات التي نجمعها  
- ملفات تعريف الارتباط (Cookies) وتقنيات مماثلة لجمع معلومات حول جهازك ومتصفحك وطريقة استخدامك للموقع.  
- بيانات التحليلات عبر Google Analytics لجمع إحصاءات حول عدد الزيارات وسلوك المستخدمين.  
- بيانات الإعلان من Google AdSense حول تفاعلك مع الإعلانات المعروضة.

2. استخدام المعلومات  
- لتحسين تجربة المستخدم وتخصيص المحتوى والإعلانات.  
- لتحليل أداء الموقع والتقارير الإحصائية.  
- لتشغيل وإدارة الخدمات التي نقدمها.

3. خدمات Google الخارجية  
- نستخدم Google Analytics لتحليل حركة الزوار. اطّلع على سياسة Google Analytics:  
  https://policies.google.com/technologies/partner-sites  
- نعرض إعلانات Google AdSense. اطّلع على سياسة Google Ads:  
  https://policies.google.com/technologies/ads

4. إدارة ملفات تعريف الارتباط والموافقة  
- يمكنك تعطيل ملفات تعريف الارتباط عبر إعدادات متصفحك.  
- لإلغاء التتبع في Google Analytics، يمكن تثبيت إضافة إلغاء التتبع من هنا:  
  https://tools.google.com/dlpage/gaoptout  
- لإدارة تفضيلاتك الإعلانية أو إلغاء الإعلانات المخصصة من Google:  
  https://adssettings.google.com/

5. مشاركة البيانات مع الأطراف الأخرى  
- لا نبيع معلوماتك الشخصية لأي جهة.  
- نشارك البيانات مع موفري الخدمات من Hosting وتحليلات وإعلانات.  
- الجهات الرئيسية: Google Inc. (AdSense, Analytics)

6. حقوقك القانونية  
- الحق في الوصول إلى بياناتك وتصحيحها أو حذفها.  
- الحق في الاعتراض على معالجة بياناتك أو تقييدها.  
لتمارس هذه الحقوق، تواصل معنا عبر البريد: privacy@camelbits.com

7. تحديث هذه السياسة  
نحن نراجع هذه السياسة من حين لآخر. أي تعديل سيُعلن عنه هنا مع تحديث التاريخ.

`;

export default privacyPolicyText;
